import React from 'react';
import { Form, Input, Button, Tooltip, Upload, Icon, Select, Radio } from 'antd';
import { sanitizeNameInput } from '../../Utils/TextTransformationUtil';
import styles from './AddCandidateContainer.module.scss';

const AddCandidateForm = props => {
  const {
    form,
    onCloseDrawer,
    beforeUpload,
    resume,
    handleUpload,
    removeResume,
    createCandidateApiStatus,
    fetchedLocations,
    handleLocationSearch,
    fetchLocationApiStatus,
    prefixSelector,
    otherSource,
    setSourceDropdown,
    sourceList,
    sourceDropdown,
    handleOtherSource,
    fetchJobsApiStatus,
    jobContext,
    onSearch,
    onChangeJobContext,
    jobIdOptions,
    handleSubmit,
  } = props;

  const dropDownStatus = (apiStatus, notFoundText) => {
    return apiStatus === 'INPROGRESS' ? <p>Loading...</p> : <p>{notFoundText}</p>;
  };

  function validatePhone(rule, value, callback) {
    const regex = /^[0-9]{6,14}$/;
    const phone = value;
    if (!phone || !phone.trim().length || regex.test(phone)) {
      callback();
    } else {
      callback('Invalid Phone Number');
    }
  }

  const { Option } = Select;
  const { getFieldDecorator } = form;
  return (
    <Form onSubmit={handleSubmit} className={styles.form}>
      <Form.Item label="Resume" name="resume" className={styles.formItem}>
        {getFieldDecorator('resume', {
          rules: [
            {
              required: true,
              message: 'Please upload a resume',
            },
            {
              validator: (rule, { file, fileList }, callback) => {
                if (resume[0].size / 1024 > 2048) {
                  callback('File cant be larger than 2 mb');
                }
                callback();
              },
            },
          ],
        })(
          <Upload.Dragger
            beforeUpload={beforeUpload}
            multiple={false}
            accept=".doc,.docx,.pdf,.txt,.html"
            customRequest={({ file, onSuccess }) => {
              onSuccess('ok');
            }}
            className={styles.uploadResume}
            fileList={resume}
            onChange={handleUpload}
            onRemove={removeResume}
            showUploadList={{
              showDownloadIcon: false,
              showRemoveIcon: true,
            }}
          >
            <p className={styles.uploadText}>
              <Icon type="upload" /> Upload Resume
            </p>
          </Upload.Dragger>
        )}
        <p className={styles.uploadHintText}>Maximum file size: 2MB | Accepted formats: doc, docx, pdf, text, html</p>
      </Form.Item>
      <Form.Item label="Full Name" name="fullName" className={styles.formItem}>
        {getFieldDecorator('fullName', {
          // Strips the invisible characters a pasted name carries before the value reaches
          // form state, so validation and submit both see what the recruiter meant to type.
          getValueFromEvent: e => sanitizeNameInput(e?.target?.value),
          rules: [
            {
              required: true,
              message: 'Please enter the full name',
            },
            {
              validator: (rule, value, callback) => {
                const nameRegex = /^[A-Za-z\s\-']+$/;
                if (value && !nameRegex.test(value)) {
                  callback("Name can only contain letters, spaces, hyphens (-), and apostrophes (')");
                  return;
                }
                callback();
              },
            },
          ],
        })(<Input placeholder="Robert Baratheon" />)}
      </Form.Item>
      <Form.Item label="Email Address" name="email" className={styles.formItem}>
        {getFieldDecorator('email', {
          rules: [
            {
              type: 'email',
              message: 'The input is not valid email',
            },
            {
              required: true,
              message: 'Please enter the email',
            },
          ],
        })(<Input placeholder="robertbaratheon@gmail.com" />)}
      </Form.Item>
      <Form.Item label="Location" name="location" className={styles.formItem}>
        {getFieldDecorator('location', {
          rules: [
            {
              required: true,
              message: 'Please enter the location',
            },
          ],
        })(
          <Select
            allowClear
            showSearch
            filterOption={false}
            showArrow
            onFocus={() => document.getElementById('location').click()}
            notFoundContent={dropDownStatus(fetchLocationApiStatus, 'No Data')}
            onSearch={value => handleLocationSearch(value)}
            getPopupContainer={node => node.parentNode}
            placeholder="City, state, country"
            className={styles.contextSearch}
          >
            {fetchedLocations.map(location => (
              <Option
                key={`${location.City}-${location.State}-${location.CountryCode}`}
                value={`${location.City}-${location.State}-${location.CountryCode}`}
              >
                {location?.City && location.City}, {location.State}, {location.CountryCode}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Form.Item label="Phone Number" name="phone" className={styles.formItem}>
        {getFieldDecorator('phone', {
          rules: [{ validator: validatePhone }],
        })(<Input addonBefore={prefixSelector} placeholder="(555) 555-1234" />)}
      </Form.Item>
      <Form.Item label="Sources" name="sources" className={styles.formItem}>
        {getFieldDecorator('sources', {
          rules: [
            { required: true, message: 'Please enter the source' },
            {
              validator: (rule, value, callback) => {
                if (value === 'Others' && !otherSource) {
                  callback('Please enter the other source');
                  return;
                }
                callback();
              },
            },
          ],
        })(
          <Select
            className={styles.sources}
            onChange={val => setSourceDropdown(val)}
            placeholder="Monster"
            getPopupContainer={node => node.parentNode}
          >
            {sourceList.map(source => (
              <Option key={source} value={source}>
                {source}
              </Option>
            ))}
          </Select>
        )}
        {sourceDropdown === 'Others' && (
          <Input
            placeholder="Enter Source"
            onChange={handleOtherSource}
            className={styles.otherSource}
            value={otherSource}
          />
        )}
      </Form.Item>
      <Form.Item label="Add To" name="jobId" className={styles.formItem}>
        <Radio.Group onChange={onChangeJobContext} value={jobContext}>
          <Radio.Button shape="round" value="Job" className={styles.contextButton}>
            Job
          </Radio.Button>
          <Radio.Button shape="round" value="Segment" className={styles.contextButton}>
            Segment
          </Radio.Button>
        </Radio.Group>
        {getFieldDecorator('jobId')(
          <Select
            allowClear
            showSearch
            filterOption={false}
            showArrow={false}
            onFocus={() => document.getElementById('jobId').click()}
            notFoundContent={dropDownStatus(fetchJobsApiStatus, `${jobContext} not found `)}
            onSearch={value => onSearch(value, jobContext)}
            getPopupContainer={node => node.parentNode}
            placeholder="Search"
            className={styles.contextSearch}
          >
            {jobIdOptions?.map(option => (
              <Option key={option.value} value={option.value}>
                {option.text}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <div className={styles.footer}>
        <Button onClick={onCloseDrawer} className={styles.cancel} shape="round">
          Cancel
        </Button>
        <Tooltip title={resume.length === 0 ? 'Upload a resume' : ''}>
          <Button
            type="primary"
            htmlType="submit"
            shape="round"
            disabled={resume.length === 0}
            loading={createCandidateApiStatus === 'INPROGRESS'}
          >
            Save
          </Button>
        </Tooltip>
      </div>
    </Form>
  );
};

export default AddCandidateForm;
